module.exports = __webpack_public_path__ + "img/book3.bbc194ac.jpg";